import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import forum_45global from "/app/middleware/forum.global.ts";
import local_45auth_45global from "/app/middleware/local-auth.global.ts";
import maintenance_45global from "/app/middleware/maintenance.global.ts";
import offline_45global from "/app/middleware/offline.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  forum_45global,
  local_45auth_45global,
  maintenance_45global,
  offline_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/middleware/auth.ts"),
  "community-admin": () => import("/app/middleware/community_admin.ts"),
  guest: () => import("/app/middleware/guest.ts")
}